module.exports = __webpack_public_path__ + "img/enterprise.e3b2c29b.svg";